import React, { useEffect, useState } from 'react'
import className from 'classnames'
import InputMask from "react-input-mask";
import Button from '../Button/Button'
import ButtonGroup from '../Button/ButtonGroup/ButtonGroup'
import FieldLabel from '../FieldLabel/FieldLabel';
import Link from '../Typography/Link/Link';
import { getTimeMaskValue, formatTimeString } from '../Datepicker/helpers'

import './Timepicker.css'

export const TimePickerMask: React.FunctionComponent = (props: any) => {
  const {
    viewType,
    initialDate,
    cancelCtaTestId,
    doneCtaTestId,
    onCancel,
    onDone,
    inputMaskTestId,
    inputMaskDisabled,
    placeholder,
    onChange,
    zone,
    timeObj,
    dstZone,
    isDateTimeCombo,
    ...rest
  } = props
  const [calenderTime, setCalenderTime] = useState(initialDate)
  const [timeInputMask, setTimeInputMask] = useState(isDateTimeCombo ? formatTimeString(initialDate) : initialDate)
  const onDoneClickHandler = () => {
    console.log(calenderTime.length, "Done Handler Value", calenderTime)
    let formattedValue = calenderTime.includes(':') ? calenderTime.split(':').map(el => el.slice(0, 2)).join(':') : calenderTime.trim() === '' ? '' : `${calenderTime.slice(0, 2)}:00:00`
    const timeValueSplit: any = formattedValue.split(":")
    if (timeValueSplit[0]?.trim().length === 1) {
      timeValueSplit[0] = `0${timeValueSplit[0].trim()}`
      formattedValue = timeValueSplit.join(":")
    }
    if (timeValueSplit[1]?.trim().length === 1) {
      timeValueSplit[1] = `0${timeValueSplit[1].trim()}`
      formattedValue = timeValueSplit.join(":")
    }
    if (timeValueSplit[2]?.trim().length === 1) {
      timeValueSplit[2] = `0${timeValueSplit[2].trim()}`
      formattedValue = timeValueSplit.join(":")
    }
    const returnTimeValue = formattedValue.trim() === '' || formattedValue === '  :  :  ' ? "HH:mm:ss" : formattedValue.replace(/[ ]/g, '0');
    if (onDone) onDone(returnTimeValue)
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const onCancelClickHandler = () => {
    if (onCancel) onCancel()
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const setCurrentTimeHandler = () => {
    let currentTimeValue = new Date().toLocaleString('en-US', { timeZone: timeObj.value, timeStyle: "medium", hourCycle: "h23" })
    if (currentTimeValue.match(/^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/) !== null) {
      setTimeInputMask(currentTimeValue)
      setCalenderTime(currentTimeValue);
      if (onChange) onChange(`${currentTimeValue}${zone ? zone : ''}`, zone || '')
    }
  }

  const onTimeInputMaskChange = (e: any): void => {
    let timeValue: any = e.target.value;
    if (timeValue) {
      const timeValueSplit: any = timeValue.split(":")
      if (timeValueSplit.length === 2) {
        if (timeValueSplit[1].length === 5) {
          const hr_input = timeValueSplit[1].slice(0, 2)
          const min_input = timeValueSplit[1].slice(3, 5)
          timeValueSplit[1] = hr_input
          timeValueSplit[2] = min_input
        } else {
          timeValueSplit.push('  ')
        }
      }
      if (timeValue && timeValueSplit) {
        if (timeValueSplit[0] && parseInt(timeValueSplit[0]?.trim()) >= 24) timeValueSplit[0] = 23
        if (timeValueSplit[1] && parseInt(timeValueSplit[1]?.trim()) > 59) timeValueSplit[1] = 59
        if (timeValueSplit[2] && parseInt(timeValueSplit[2]?.trim()) > 59) timeValueSplit[2] = 59
      }
      timeValue = timeValueSplit.join(":")
      setTimeInputMask(timeValue)
      setCalenderTime(timeValue);
      if (onChange) onChange(`${timeValue}${zone ? zone : ''}`, zone || '')
    }
  }

  return (
    <>
      <div
        className={className('TimePicker', {
          'TimePicker__date-time': viewType === 'datetime'
        })}
      >
        <div className={'TimePicker--time TimePicker__v2'} >
          <FieldLabel testId={`${inputMaskTestId}-label`} className='TimePicker__title__v2' htmlFor='time' version="v2">Enter Time</FieldLabel>
          <div className={'flex TimePicker__container TimePicker__container__v2'}>
            <InputMask
              disable={inputMaskDisabled || false}
              data-test-id={inputMaskTestId || `cs-time-input-field`}
              // mask="99:99:99"
              mask={getTimeMaskValue(timeInputMask)}
              maskPlaceholder=" "
              placeholder={"HH:mm:ss"}
              className="date__input"
              value={timeInputMask}
              onChange={onTimeInputMaskChange}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  e.stopPropagation()
                  e.preventDefault()
                }
              }}
            />
          </div>
          <Link testId='cs-current-time-link' cbOnClick={setCurrentTimeHandler} className="flex-center " fontSize={'regular'} fontWeight={'semi-bold'} underline={true} underLineType="solid">Use Current Time</Link>
        </div>
        <div className="TimePicker__actions flex-right">
          <ButtonGroup>
            <Button testId={`${cancelCtaTestId ? cancelCtaTestId : 'cs-time-picker-cancel'}`} buttonType="tertiary" version='v2' onClick={onCancelClickHandler}>
              Cancel
            </Button>
            <Button testId={`${doneCtaTestId ? doneCtaTestId : 'cs-time-picker-done'}`} buttonType="primary" version='v2' onClick={onDoneClickHandler} >
              Apply
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </>
  )
}